import React from "react";

import { Helmet } from "react-helmet";

import { Clients } from "features/Clients";
import { PageTitle } from "shared/ui";

const TITLE = "Клиенты";

// Тонкая обёртка над фичей: ставит chrome страницы и отдаёт всё остальное features/Clients.
const ClientsListPage = () => {
    return (
        <>
            <PageTitle>{TITLE}</PageTitle>
            <Helmet title={TITLE} />
            <Clients />
        </>
    );
};

export default ClientsListPage;
